import { render, staticRenderFns } from "./CheckBoxEditor.vue?vue&type=template&id=3954ccab&scoped=true&"
import script from "./CheckBoxEditor.vue?vue&type=script&lang=js&"
export * from "./CheckBoxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954ccab",
  null
  
)

export default component.exports